/** A note above a mock on when production shows that state. */
export function StateDescription({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-1">
      <h2 className="text-ink text-sm font-semibold">{title}</h2>
      <p className="text-ink-600 text-xs leading-relaxed">{children}</p>
    </div>
  )
}
